import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UsuarioDTOModel } from 'src/app/account/models/usuario-dto.model';
import { ErrorModel } from 'src/app/core/models/error.model';
import { LocalStorage } from 'src/app/core/utils/local.storage';
import { LayoutService } from 'src/app/layout/layout.module';
import { DialogService } from 'src/app/layout/services/dialog.service';
import { MfgModel } from '../../models/mfg.model';
import { MfgService } from '../../services/mfg.service';

@Component({
  selector: 'app-mfg',
  templateUrl: './mfg.component.html',
  styleUrls: ['./mfg.component.scss']
})
export class MfgComponent implements OnInit {
  formGroup: FormGroup;
  mfgModel = new MfgModel();
  loading = false;
  errorMessage: string;
  successMessage: string;
  isSending = false;

  constructor(
      private formBuilder: FormBuilder,
      private mfgService: MfgService,
      private layoutService: LayoutService,
      private dialogService: DialogService,
  ) { }

  ngOnInit(): void {
    this.loading = true;
    this.mfgService.getMfg().subscribe(result => {
      //console.log(result);
      this.mfgModel.funcao = result[0].funcao;
      this.mfgModel.geografia = result[0].geografia;
      this.mfgModel.mercado = result[0].mercado;
    }, (error: ErrorModel) => {
      this.dialogService.showAlert(error.message);
    }).add(() => this.loading = false)

    this.formGroup = this.formBuilder.group({
      email: [, Validators.compose([Validators.required])],
      contribuicao: [null, Validators.compose([Validators.required, Validators.minLength(10)])],
    });

    const userDTO: UsuarioDTOModel = LocalStorage.getItem('usuarioSistemaDTO');
    if (userDTO) {
      this.formGroup.get('email').setValue(userDTO.email);
    }
  }

  enviarMensagem(): void {
    console.log(this.formGroup.value);

    if (!this.formGroup.valid) {
      this.errorMessage = 'Preenchimento obrigatório.'
      return;
    }
    
    this.isSending = true;
    this.mfgService.postContribuicoes(this.formGroup.value).subscribe(results => {
      this.formGroup.get('contribuicao').setValue(null);
      this.successMessage = 'Contribuição enviada com sucesso.';
    }, (error: ErrorModel) => {
      console.log('Errors');
      console.log(error);
    }).add(() => this.isSending = false)
    
    this.errorMessage = null;
  }
}
